import { action, makeObservable, observable } from 'mobx';

import {
  DATA_TABLE_STATE_PREFIX,
  DATAGRID_ID_PREFIX,
} from '~components/DataTable/dataTableStorageKeys';
import { clearMessagingDrafts } from '~services/messagingDraftStorage';
import { clearImpersonation } from '~services/sessionTokens';
import { RootStore } from '~store/RootStore';

class AuthStore {
  isAuthenticated = false;
  isRedirectToMobileNeeded = false;
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeObservable(this, {
      isAuthenticated: observable,
      login: action,
      logout: action,
      setRedirectToMobileNeeded: action,
    });
    this.rootStore = rootStore;
  }

  login(): void {
    this.isAuthenticated = true;
  }

  logout(): void {
    this.isAuthenticated = false;
    // logging out ends the impersonated session too, not just the admin's own.
    clearImpersonation();
    clearMessagingDrafts();
    this.#clearLocalStorage();
    this.rootStore.userStore.clearUser();
  }

  #clearLocalStorage() {
    const storedKeys = Array.from({ length: localStorage.length }, (_, index) =>
      localStorage.key(index),
    );

    storedKeys.forEach((key) => {
      const isTableLayoutPreference =
        key?.startsWith(DATAGRID_ID_PREFIX) || key?.startsWith(DATA_TABLE_STATE_PREFIX);

      if (key && !isTableLayoutPreference) {
        localStorage.removeItem(key);
      }
    });
  }

  setRedirectToMobileNeeded(param: boolean): void {
    this.isRedirectToMobileNeeded = param;
  }
}

export default AuthStore;
